const SECURITY_CONTEXT_COOKIE = 'x-egto-security-context';

export class ChooseMechanismController {
    /* @ngInject */
    constructor($cookies, destinationInstallation, chooseMechanismService, chosenAuthenticationMechanisms) {
        this.chooseMechanismService = chooseMechanismService;
        this.destinationInstallation = destinationInstallation;
        this.installationAuthenticationMechanisms = destinationInstallation ? destinationInstallation.installationAuthenticationMechanisms : [];
        this.chosenAuthenticationMechanisms = chosenAuthenticationMechanisms;
        let securityContextCookie = $cookies.get(SECURITY_CONTEXT_COOKIE);
        this.destinationSecurityContext = securityContextCookie ? securityContextCookie.toUpperCase() : 'MAIN';
    }

    chooseMechanism(mechanism) {
        this.chooseMechanismService.choose(mechanism, this.isChosenMechanism(mechanism));
    }

    isChosenMechanism(mechanism) {
        for (let i in this.chosenAuthenticationMechanisms) {
            if (this.chosenAuthenticationMechanisms.hasOwnProperty(i) &&
                this.chosenAuthenticationMechanisms[i].id === mechanism.id) {
                return true;
            }
        }
        return false;
    }

    getMechanismType(mechanism) {
        if (mechanism.authenticationMechanism.type === 'OAUTH' || mechanism.authenticationMechanism.type === 'SAML') {
            return mechanism.authenticationMechanism.type;
        }
        return mechanism.securityContext;
    }

    getLogoUrl(mechanism) {
        switch (mechanism.authenticationMechanism.type) {
            case 'PASSWORD_CREDENTIALS':
                var destinationUrl = this.destinationInstallation.baseUrl;
                while(destinationUrl.indexOf('/', destinationUrl.length - 1) !== -1) {
                    destinationUrl = destinationUrl.substring(0, destinationUrl.length - 1);
                }
                var baseUrl = destinationUrl + '/' + this.destinationInstallation.workerName + '/graphic/ws/';
                if (mechanism.securityContext === 'EXTRANET') {
                    return baseUrl + 'extranetLogo';
                }
                return baseUrl + 'systemLogo';
            default:
                return;
        }
    }
}
